import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpService } from 'src/app/modules/core/services/http.service';
import { AuthToken } from '../../authentication/store/auth';
import { ProfilePreferences, CheckSmsOptInResponse } from './notification-prefs.model';
import { Dataset } from '@app/modules/core/store/models';
import { RatingArea, RatingScale } from '@app/modules/management/store/ratings/ratings.model';

import { API_BASE_URL as apiBaseUrl } from '@app/core/constants/api-base-url';

@Injectable({
  providedIn: 'root'
})
export class NotificationPrefsApiService {
  constructor(private http: HttpService) {}

  sendOneTimeAuthEmail(orgCode: string, email: string, cultureCode: string, recaptchaToken: string): Observable<void> {
    const url = `${apiBaseUrl}/v1/iam/auth/preferences-onetime-email`;
    return this.http.post(url, { orgCode, email, cultureCode, recaptchaToken });
  }

  sendOneTimeAuthPhone(orgCode: string, phone: string, cultureCode: string, recaptchaToken: string): Observable<void> {
    const url = `${apiBaseUrl}/v1/iam/auth/preferences-onetime-phone`;
    return this.http.post(url, { orgCode, phone, cultureCode, recaptchaToken });
  }

  sendOneTimeAuthWhatsApp(orgCode: string, phone: string, cultureCode: string, recaptchaToken: string): Observable<void> {
    const url = `${apiBaseUrl}/v1/iam/auth/preferences-onetime-whatsapp`;
    return this.http.post(url, { orgCode, phone, cultureCode, recaptchaToken });
  }

  processAuthCode(orgCode: string, code: string, userKey: string, cultureCode: string): Observable<AuthToken> {
    const url = `${apiBaseUrl}/v1/iam/auth/auth-for-preferences`;
    return this.http.post(url, { orgCode, code, userKey, cultureCode });
  }

  getNotificationPreferences(): Observable<ProfilePreferences> {
    const url = `${apiBaseUrl}/v1/iam/preferences`;
    return this.http.get(url);
  }

  getNotificationPreferencesDataset(datasetUId: string): Observable<Dataset> {
    const url = `${apiBaseUrl}/v1/iam/preferences/dataset/${datasetUId}`;
    return this.http.get(url);
  }

  updateNotificationPreferences(preferences: ProfilePreferences): Observable<ProfilePreferences> {
    const url = `${apiBaseUrl}/v1/iam/preferences`;
    return this.http.put(url, preferences);
  }

  processAuthCodeForField(orgCode: string, code: string, userKey: string, fieldName: string): Observable<ProfilePreferences> {
    const url = `${apiBaseUrl}/v1/iam/preferences/verify-code-for-field`;
    const data = { orgCode, code, userKey, fieldName };
    return this.http.post(url, data);
  }

  checkSmsOptIn(orgCode: string, phone: string, recaptchaToken: string): Observable<CheckSmsOptInResponse> {
    const url = `${apiBaseUrl}/v1/iam/preferences/check-sms-opt-in`;
    const data = { orgCode, phone, recaptchaToken };
    return this.http.post(url, data);
  }

  storeSmsOptIn(orgCode: string, phone: string, recaptchaToken: string): Observable<any> {
    const url = `${apiBaseUrl}/v1/iam/preferences/store-sms-opt-in`;
    const data = { orgCode, phone, recaptchaToken };
    return this.http.post(url, data);
  }

  getNotificationRatingScale(): Observable<RatingScale> {

    const url = `${apiBaseUrl}/v1/meta/ratings/area/${RatingArea.Notification}`;
    return this.http.get<RatingScale>(url);
  }
}
